import React from 'react'
import whatsapp from '../Images/Sticky-social-img/whatsapp.png'
import call from '../Images/Sticky-social-img/call.jpg'
import share from '../Images/Sticky-social-img/share.png'
import youtube from '../Images/Sticky-social-img/youtube.jpg'

const StickySocials = () => {
  return (
    <div className="sticky-socials">
      <a href='https://www.youtube.com/@BBarnaEdu' target="_blank" rel="noopener noreferrer">
        <img src='https://www.state.gov/wp-content/uploads/2020/07/72-729738_youtube-red-circle-circle-youtube-logo-png-clipart.jpg' />
      </a>
      <a href="tel:+917001739646" target="_blank" rel="noopener noreferrer">
        <img src={call} />
      </a>
      <a href="https://wa.me/917001739646" target="_blank" rel="noopener noreferrer">
        <img src={whatsapp} />
      </a>
      <a
        href="#"
        title="Share"
        onClick={(e) => {
          e.preventDefault();
          if (navigator.share) {
            navigator.share({
              title: document.title,
              text: "Check out this site!",
              url: window.location.href,
            }).catch((error) => console.error("Error sharing", error));
          } else {
            alert("Sharing not supported on this browser.");
          }
        }}
      >
        <img
          src={share}
          alt="Share"
          className="w-8 h-8"
        />
      </a>

    </div>
  )
}

export default StickySocials